import { inject } from 'mobx-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { InjectTranslate } from '../app/app';

class RedeemHeaderC extends React.Component<InjectTranslate> {
  public render() {
    const { t } = this.props;

    return (
      <div className="redeem-header">
        <h2>{t('send.header')}</h2>
        {/* tslint:disable-next-line:jsx-use-translation-function */}
        <div className="redeem-back">
          {/* tslint:disable-next-line:jsx-use-translation-function */}
          <Link to={'/segment'}>×</Link>
        </div>
      </div>
    );
  }
}

export const RedeemHeader: React.ComponentClass = inject('t')(RedeemHeaderC);



// WEBPACK FOOTER //
// ../node_modules/source-map-loader!./src/components/redeem/redeem-header.tsx